import React, {useEffect} from 'react'
import {Modal } from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {fetchBillerDetails} from '../../actions'
import {Row, Col} from 'react-bootstrap'
import moment from 'moment'
import {BILLER_DETAILS_LOADING_ID} from '../../store/loaders'
import background_icon from '../../assets/images/background-icon.png'
import Table from 'react-bootstrap/Table'
import { PDFDownloadLink } from '@react-pdf/renderer';
import ReceiptPDF from '../../components/downloadPdf/billerReceiptPdf'



import LoadingSpinner from '../../components/loadingSpiner'



const BillModel = (props)=>{

    const {billerId} = props

    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {billDetails, loader} = state
        const {data} = billDetails
        const {isLoading} = loader[BILLER_DETAILS_LOADING_ID] || {isLoading: false}
        return{
            data,
            isLoading
        }
    })

    const actionLoader = apiResponse.isLoading
    useEffect(()=>{
        if(billerId){
            dispatch(fetchBillerDetails(billerId))
        }
    },[billerId])

    console.log("I am details", apiResponse?.data)  
    return(
        <Modal
            show={props.show}
            onHide={props.hide}
            centered
            size="xl"
            className="model-details">
                {actionLoader ? <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'}}>
            <LoadingSpinner
                color={'#1D834F'}/>
        </div>:
                <>
                <div class="image-container">
                    <img src={background_icon} style={{height: 200, width: 200}}/>
                    <div class="after"></div>
                </div>
                <Row className="biller-cols">
                    <Col sm="8" style={{marginTop: 50}}> 
                        <Table striped hover responsive>
                                <thead>
                                        <tr>
                                            <th style={{color: '#2596bc'}}>Item Type</th>
                                            <th style={{color: '#2596bc'}}>Description</th>
                                            <th style={{color: '#2596bc'}}>Amount</th>
                                        </tr>
                                </thead>
                                    <tbody>
                                        <tr>
                                            <td>{apiResponse.data?.itemType}</td>
                                            <td>{apiResponse.data?.description}</td>
                                            <td>RWF {apiResponse.data?.amount}</td>
                                        </tr>
                                    </tbody>
                        </Table>
                    </Col>
                    <Col> 
                        <div className="biller-details-left-section">
                            <span>Amount Due (RWF)</span>
                            <p style={{fontSize: 40, fontWeight: 'bold'}}>RWF {apiResponse.data?.amount}</p>
                            <span>Billed To</span>
                            <p>Kwizera Steve</p>
                            <span>Invoice Number</span>
                            <p>{apiResponse.data?.id}</p>
                            <span>Date of Issue</span>
                            <p>{moment(apiResponse.data?.recordDate).format('MMMM Do YYYY, h:mm:ss a')}</p>
                        </div>
                     </Col>
                </Row>
                



                <div className="react-divider"></div>
                <div style={{
                marginBottom: 20,
                marginTop: 20,}}>
                <PDFDownloadLink document={<ReceiptPDF data={apiResponse.data}/>} fileName="receipt.pdf" style={{
                    backgroundColor: '#0E348A',
                    padding: '15px 20px',
                    marginLeft: 50,
                    textDecoration: 'none',
                    color: 'white'
                }}>
                {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download Receipt')}
                </PDFDownloadLink>
            </div>
                 {/* <Row className="biller-details-row grey-row">
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">ID</span>
                        <a>{apiResponse.data?.id}</a>
                   </Col>
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">Date</span>
                        <a>{moment(apiResponse.data?.recordDate).format('MMMM Do YYYY, h:mm:ss a')}</a>
                   </Col>
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">Item type</span>
                        <a>{apiResponse.data?.itemType}</a>
                   </Col>
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">Amount</span>
                        <a>{apiResponse.data?.amount}</a>
                   </Col>
               </Row> */}
               {/* <Row className="biller-details-row">
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">Description</span>
                        <a>{apiResponse.data?.description}</a>
                   </Col>
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">Reference ID</span>
                        <a>{apiResponse.data?.referenceId}</a>
                   </Col>
                   <Col className="biller-details-col">
                        <span className="text-field-names-title">Status</span>
                        <a>{apiResponse.data?.status}</a>
                   </Col>
                   <Col>
                   </Col>
               </Row> */}
                </>
                }
        </Modal>
    )
}

export default BillModel